import { useState } from 'react';
import { Link } from 'react-router';
import { useEvents } from '../api/events';

function statusOf(e: {
  publishedAt: string | null;
  archivedAt: string | null;
  startsOn: string;
  endsOn: string;
}): { label: string; className: string } {
  if (e.archivedAt) return { label: 'archived', className: 'pill pill-ended' };
  if (!e.publishedAt) return { label: 'draft', className: 'pill pill-draft' };
  const today = new Date().toISOString().slice(0, 10);
  if (today < e.startsOn) return { label: 'upcoming', className: 'pill pill-upcoming' };
  if (today > e.endsOn) return { label: 'ended', className: 'pill pill-ended' };
  return { label: 'live', className: 'pill pill-live' };
}

export function EventsList() {
  const [includeArchived, setIncludeArchived] = useState(false);
  const events = useEvents({ includeArchived });

  return (
    <div className="page">
      <div className="page-head">
        <h1>Events</h1>
        <div className="page-actions">
          <label className="micro" style={{ display: 'inline-flex', gap: 6, alignItems: 'center' }}>
            <input
              type="checkbox"
              checked={includeArchived}
              onChange={(e) => setIncludeArchived(e.target.checked)}
            />
            Show archived
          </label>
          <Link to="/events/new" className="btn btn-primary">
            New event
          </Link>
        </div>
      </div>

      {events.isPending && <div className="loading">Loading…</div>}
      {events.isError && <div className="error">Could not load events.</div>}
      {events.data && events.data.length === 0 && (
        <div className="empty">
          <p>No events yet.</p>
          <Link to="/events/new" className="btn btn-primary">
            Create the first event
          </Link>
        </div>
      )}
      {events.data && events.data.length > 0 && (
        <div className="card">
          <table className="tbl">
            <thead>
              <tr>
                <th>Name</th>
                <th>Code</th>
                <th>Dates</th>
                <th>Status</th>
                <th aria-label="Open" />
              </tr>
            </thead>
            <tbody>
              {events.data.map((e) => {
                const s = statusOf(e);
                return (
                  <tr key={e.id}>
                    <td>{e.name}</td>
                    <td>
                      <span className="micro">{e.shortCode}</span>
                    </td>
                    <td>
                      <span className="micro">
                        {e.startsOn} → {e.endsOn}
                      </span>
                    </td>
                    <td>
                      <span className={s.className}>{s.label}</span>
                    </td>
                    <td>
                      <Link
                        to={`/events/${e.id}/setup`}
                        className="btn btn-ghost btn-sm"
                      >
                        Open
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
